import { Button } from '@app/components/various/Button';
import { Dropdown, DropdownMenu, DropdownTrigger } from '@app/components/various/Dropdown';
import { getProductSortingFields } from '@app/ducks';
import { Sorting } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useAllProductsContext } from '../context/AllProductsContext';

interface Props {
  onSelect: (value: Sorting.FieldValue) => void;
}

export const ProductSorting = ({ onSelect }: Props) => {
  const { t } = useTranslation(['common']);
  const sortingFields = useSelector(getProductSortingFields);
  const { sort } = useAllProductsContext();

  const handleSelect = React.useCallback(
    (value: Sorting.FieldValue) => {
      onSelect(value);
      window.scrollTo({ top: 0 });
    },
    [onSelect],
  );

  return (
    <Dropdown title={t('common:sort_by')}>
      <DropdownTrigger>
        {({ isOpen, triggerProps }) => (
          <Button size="medium" variant="bordered" color="secondary" isChevronOpen={isOpen} {...triggerProps}>
            {t('common:sort_by')}
          </Button>
        )}
      </DropdownTrigger>
      <DropdownMenu
        selectionMode="single"
        selectedKeys={[sort]}
        items={sortingFields.map(({ field, name }) => ({ key: field, label: name }))}
        onSelectionChange={([value]) => handleSelect(value as Sorting.FieldValue)}
      />
    </Dropdown>
  );
};
